import React from "react";
import { css, Theme, useTheme } from "@emotion/react";
import ContentCombine from "core/Components/ContentCombine";

type Props = {
    data: ContentWithList
};

const Header: React.FC<Props> = ({ data }) => {
    const theme: Theme = useTheme();
    const colourTheme = JSON.parse(data.theme);
    const { headerColour } = colourTheme;

    const headerStyle = css`
        width: 96%;
        font-weight: ${theme.fonts.weights.bold};
        margin-bottom: 22px;
        padding-left: 38px;

        ${headerColour && css`
            color: ${headerColour};
        `}
        
        ${theme.breakpoints.up("5xl")} {
            margin-bottom: 44px;
            padding-left: 91px;
        }

        ${theme.breakpoints.between("3xl", "4xl")} {
            margin-bottom: 20px;
        }

        ${theme.breakpoints.only("xl")} {
            margin-bottom: 22px;
            padding-left: 20px;
        }

        ${theme.breakpoints.only("lg")} {
            margin-bottom: 24px;
            padding-left: 31px;
        }
        
        ${theme.breakpoints.only("md")} {
            margin-bottom: 0;
            padding-left: 42px;
        }

        ${theme.breakpoints.only("sm")} {
            margin-bottom: 10px;
            padding-left: 32px;
        }

        ${theme.breakpoints.down("xs")} {
            margin-bottom: 8px;
            padding-left: 15px;
        }
    `;

    return (
        <ContentCombine Tag={'h2'} css={headerStyle}>{data.header}</ContentCombine>
    );
};

export default Header;
